import { useDatePartsFormatter } from 'common/hooks';

export const useFormattedDate = (date: Date) => {
  const { day, month, year } = useDatePartsFormatter({
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })(date);

  return `${day} ${month}, ${year}`;
};
